export default class Logger {
    static log(msg) {
        if (this.active)
            console.log(msg);
    }
}
Logger.active = false;
